function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export class GrpcLayoutStorage {
  /**
   *
   * @param storageService The gRPC storage service to use
   * @param root The root path where the layouts are stored
   */
  constructor(storageService) {
    var root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    _defineProperty(this, "storageService", void 0);
    _defineProperty(this, "root", void 0);
    this.storageService = storageService;
    this.root = root;
  }
  getLayouts() {
    var _this = this;
    return _asyncToGenerator(function* () {
      var files = yield _this.storageService.listItems(_this.root, '*.json');
      return files.map(file => file.basename);
    })();
  }
  getLayout(name) {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      var fileContents = yield _this2.storageService.loadFile("".concat(_this2.root, "/").concat(name));
      var content = yield fileContents.text();
      return JSON.parse(content);
    })();
  }
}
export default GrpcLayoutStorage;
//# sourceMappingURL=GrpcLayoutStorage.js.map